import { Box, Typography } from "@mui/material";
import { BaseModalComponent } from "../../common/BaseModalComponent";
import { APP_CATEGORIES } from "../constants/appCategories.config";
import { AppConfig } from "../interfaces/appIntegration.interfaces";
import { AppCategory } from "../types/appIntegration.types";
import { AppCard } from "./AppCard";
import { AppDetail } from "./app-detail/AppDetail";
import { useAppSelector } from "../../../redux/hooks/redux";
import { selectCurrentCompany } from "../../../redux/features/user/selectors/userState.selectors";

interface Props {
  category: AppCategory;
  apps: AppConfig[];
}

export const AppCategorySection = ({ category, apps }: Props) => {
  const currentCompany = useAppSelector(selectCurrentCompany)

  if (apps.length === 0) return null;


  const info = APP_CATEGORIES[category];

  return (
    <Box sx={{ mb: 5 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 3 }}>
        <Typography sx={{ fontWeight: 700 }}>{info.name}</Typography>

        <Box
          sx={{
            width: 22,
            height: 22,
            borderRadius: "50%",
            backgroundColor: "#7c7c7c",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 400,
          }}
        >
          {apps.length}
        </Box>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
            lg: "repeat(4, 1fr)",
          },
          gap: 3,
        }}
      >
        {apps.map((app) => {

          const isInstalled = app.companyIntegrations?.some((integration) => integration.companyId === currentCompany?.id);
          app.isInstalled = isInstalled;

          return (
            <BaseModalComponent modalLabel={`${app.name} - App`} modalKey={`${app.id}`} elementTrigger={<AppCard key={app.id} app={app} />}>
              <AppDetail app={app} onInstall={(appId) => console.log("Instalar:", appId)} onUninstall={(appId) => console.log("Desinstalar:", appId)} />
            </BaseModalComponent>
          )
        })}
      </Box>
    </Box>
  );
};
